import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { PassageOrderEmployeeFindInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order-employee/passage-order-employee-find.dto';

import * as yup from 'yup';

/** Passage order create/update API request body - DTO signature */
export interface PassageOrderFormInterface {
  /** Client this order belongs to */
  client: ClientFindInterface;
  /** Description this passage order */
  description?: string;
  /** External user who created this passage order */
  externalUser?: ExternalUserFindInterface;
  /** User who created this passage order */
  createdBy?: UserFindInterface;
  /** Responsible user this passage order */
  responsible?: UserFindInterface;
  /** Related employees */
  employees: PassageOrderEmployeeFindInterface[];
}

/** Passage order create/update API request body - DTO schema */
export const PassageOrderFormDto = SerdeDtoClass.create<PassageOrderFormInterface>(PacsDtoKeysEnum.PASSAGE_ORDER_FORM_DTO, {
  client: {
    sortable: true,
    label: 'Клиент',
    serializer: entityLikeSchema,
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  externalUser: {
    optional: true,
    sortable: true,
    label: 'Внешний пользователь',
    serializer: entityLikeSchema,
  },
  createdBy: {
    optional: true,
    sortable: true,
    label: 'Пользователь',
    serializer: entityLikeSchema,
  },
  responsible: {
    optional: true,
    sortable: true,
    label: 'Ответственный',
    serializer: entityLikeSchema,
  },
  employees: {
    label: 'Сотрудники',
    serializer: yup.array(yup.mixed()),
  },
});
